import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9e663402"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e663402')) {
      api.createRecord('9e663402', component.options)
    } else {
      api.reload('9e663402', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9e663402", function () {
      api.rerender('9e663402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nested/menu1/menu1-2/index.vue"
export default component.exports